import { render, staticRenderFns } from "./VPaymentError.vue?vue&type=template&id=fe5df118&scoped=true&"
import script from "./VPaymentError.vue?vue&type=script&lang=js&"
export * from "./VPaymentError.vue?vue&type=script&lang=js&"
import style0 from "./VPaymentError.vue?vue&type=style&index=0&id=fe5df118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5df118",
  null
  
)

export default component.exports